import { render, staticRenderFns } from "./UnassignedStudents.vue?vue&type=template&id=33c7dfec&"
import script from "./UnassignedStudents.vue?vue&type=script&lang=js&"
export * from "./UnassignedStudents.vue?vue&type=script&lang=js&"
import style0 from "./UnassignedStudents.vue?vue&type=style&index=0&id=33c7dfec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports